// EN
export const listingRatesManager = {
  header: {
    eyebrow: "Tarifas derivadas",
    title: "Tarifas do anúncio",
    subtitle:
      "Centralize a configuração das suas tarifas e aplique-a às unidades que precisar, mesmo em vários anúncios, sem repetir o trabalho uma a uma.",
    newRate: "Nova tarifa",
  },
  baseInfo: {
    title: "Preços base por noite",
    perNight: "/ noite",
    hint: "As tarifas derivadas são calculadas como um ajuste (% ou valor fixo) sobre esses preços base.",
  },
  states: {
    loading: "Carregando tarifas do anúncio...",
    emptyTitle: "Ainda não há tarifas derivadas",
    emptyText:
      "Crie uma tarifa derivada para sincronizar preços com canais como Booking.com ou Airbnb.",
    createFirst: "Criar primeira tarifa",
  },
  group: {
    unitsCount: "{count} unidade | {count} unidades",
    manageTitle: "Gerenciar grupo de tarifas",
    manage: "Gerenciar",
    modalTitle: "Gerenciar tarifa",
    apply: "Aplicar",
    appliedUnits: "Unidades onde está aplicada",
    removeSyncedWarn:
      "Esta tarifa está conectada ao canal. Removê-la também a excluirá do canal.",
    removeConfirm: "Remover esta tarifa desta unidade?",
    removing: "Removendo...",
    confirmRemove: "Sim, remover",
    removeTitle: "Remover desta unidade",
    remove: "Remover",
  },
  chips: {
    connect: "Conectar",
    paused: "Pausada",
    syncedTitle: "Sincronizada com o canal",
  },
  actions: {
    editTitle: "Editar tarifa",
    duplicateTitle: "Duplicar ou copiar",
    pause: "Pausar vendas",
    resume: "Retomar vendas",
    deleteTitle: "Excluir",
  },
  modal: {
    createTitle: "Nova tarifa derivada",
    editTitle: "Editar tarifa",
    importPlaceholder: "Copiar de uma tarifa existente…",
    namePlaceholder: "Nome da tarifa",
    percentage: "% Porcentagem",
    fixed: "Valor fixo",
    derivationHint: "Um valor negativo reduz o preço base; um positivo o aumenta.",
    searchPlaceholder: "Buscar…",
    unitsCounter: "{selected} / {total} unidades",
    selectAll: "Selecionar todas",
    deselectAll: "Limpar todas",
    loadingUnits: "Carregando…",
    currentBadge: "Atual",
    unitsWithRate: "{count} unidade com tarifa | {count} unidades com tarifa",
    noBaseRate: "Sem tarifa base",
    noResults: 'Nenhum resultado para "{query}"',
    create: "Criar tarifa",
    creating: "Criando…",
    save: "Salvar",
    saving: "Salvando…",
  },
  delete: {
    title: "Excluir tarifa derivada",
    subtitle: "Confirme o nome para evitar excluir uma tarifa por engano.",
    confirmCopy: "Digite o nome da tarifa para confirmar:",
    deleting: "Excluindo...",
  },
  types: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Quarto",
    studio: "Estúdio",
    camping: "Camping",
    default: "Acomodação",
  },
  misc: {
    noName: "Sem nome",
    unitFallback: "Unidade #{id}",
    basePrefix: "Base:",
  },
  common: {
    cancel: "Cancelar",
    delete: "Excluir",
    close: "Fechar",
  },
  toasts: {
    loadError: "Não foi possível carregar as tarifas do anúncio",
    loadListingsError: "Não foi possível carregar os anúncios",
    selectUnit: "Selecione ao menos uma unidade com tarifa base.",
    created: "Tarifa criada com sucesso",
    createdPartial: "Algumas tarifas não puderam ser criadas",
    createError: "Não foi possível criar a tarifa",
    updated: "Tarifa atualizada com sucesso",
    updateError: "Não foi possível atualizar a tarifa",
    updateErrorGeneric: "Erro ao atualizar a tarifa",
    deleted: "Tarifa excluída",
    deleteError: "Erro ao excluir",
    groupUpdated:
      "Tarifa atualizada em {count} unidade | Tarifa atualizada em {count} unidades",
    groupUpdatedPartial: "{success} atualizadas, {error} com erros",
    removedFromUnit: "Tarifa removida desta unidade",
    removeError: "Não foi possível remover a tarifa",
    removeErrorGeneric: "Erro ao remover a tarifa",
    toggleError: "Não foi possível alterar o status da tarifa",
  },
};
